import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleMouthBouche7 = customSolarIconWrapper(<g transform="translate(99 159.5)">
	<rect width="42" height="11" rx="5.5" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleMouthBouche7;
